import { Component, TemplateRef, ViewChild } from '@angular/core';
import { 
  CtModelConfiguration, 
  CtModelOperator, 
  CtModelService, 
  MAT_RAISED_PRIMARY,
  CtExportConfiguration  // ✅ NUOVO IMPORT
} from '@ctsolution/ct-framework';
import { WorkOrderPaymentRouteData } from '../../../_core/route-data/work-order-payment.route-data';
import { CTMGeneralService } from '../../../_core/lib/general.service';
import { Router } from '@angular/router';
import { DEFAULT_DATATABLE_CONFIGURATION } from '../../../_core/constants';
import { CTConfigurationModel } from 'projects/ct-manager/src/app/_core/classes/ct-configuration-model';
import { CtManagerService } from '../../../_core/lib/ct-manager.service';

@Component({
  selector: 'app-payments-list',
  templateUrl: './payments-list.component.html',
  styleUrls: ['./payments-list.component.scss']
})
export class PaymentsListComponent {

  // ✅ RIMOSSO: exportDownloadAttachmentButton
  // Il bottone export viene ora gestito automaticamente dal framework
  // tramite CtExportConfiguration nella configuration

  @ViewChild("legendTemplate") legendTemplate: TemplateRef<any> | null = null;

  paymentConfiguration: CTConfigurationModel = CTConfigurationModel.create().setVisible(false);

  configuration: CtModelConfiguration<PaymentsListComponent> = CtModelConfiguration
    .create<PaymentsListComponent>()
    .setRouteData(WorkOrderPaymentRouteData())
    .setOperations([
      CtModelOperator.Update,
      CtModelOperator.Detail,
      CtModelOperator.Export  // ✅ AGGIUNTO: Abilita operazione export
    ])
    .setCTDatatableConfiguration(DEFAULT_DATATABLE_CONFIGURATION())
    
    // ========================================
    // ✅ NUOVA CONFIGURAZIONE EXPORT
    // ========================================
    // Sostituisce exportDownloadAttachmentButton e downloadExcel()
    // Funzionalità:
    // - Bottone "Esporta" blu nella toolbar
    // - Chiama: POST /workorderpayment/ExportExcelWorkOrderPayment
    // - Passa automaticamente tutti i filtri attivi della tabella
    // - File scaricato: pagamenti.xlsx
    // - Esporta tutti i record (ignora paginazione)
    .setExportConfiguration(
      CtExportConfiguration
        .create()
        // Action backend (corrisponde a quella in downloadExcel())
        .setAction('ExportExcelWorkOrderPayment')
        // Label bottone (corrisponde a exportDownloadAttachmentButton)
        .setLabel('Esporta')
        // Icona bottone (corrisponde a exportDownloadAttachmentButton)
        .setIcon('download')
        // Nome file per il download (senza estensione)
        .setFileName('pagamenti')
        // Colore bottone blu (corrisponde a exportDownloadAttachmentButton)
        .setMaterialOptions(MAT_RAISED_PRIMARY)
        // Esporta tutti i record ignorando la paginazione (default: false)
        // Corrisponde al comportamento di downloadExcel() che fa setPagination(null)
        .setIncludePagination(false)
    )
    
    .setOnEdit(event => this.general.navigateOnCTModelRouter(["payments"], "edit", {
      value: event,
      configuration: this.configuration!
    }))
    .setOnDetail(event => this.router.navigate(["work-order", "edit", event.WorkOrder.Oid!.toString()]));

  constructor(
    private general: CTMGeneralService, 
    private router: Router, 
    private modelService: CtModelService<PaymentsListComponent>, 
    private managerService: CtManagerService
  ) {}

  async ngOnInit() {
    await this.managerService.getComponentOverride("payments", "paymentConfiguration", this.paymentConfiguration).then((component) => {
      return;
    });
  }

  ngAfterViewInit(): void {
    this.setup()
  }

  setup() {
    this.configuration.setLegendTemplate(this.legendTemplate);

    this.configuration
      .initialized()
      .subscribe(() => this.configuration?.setOperations([
        CtModelOperator.Update,
        CtModelOperator.Detail,
        CtModelOperator.Export  // ✅ AGGIUNTO: Mantieni Export anche qui
      ]));
  }

  // ✅ RIMOSSO: downloadExcel()
  // La logica di export è ora gestita automaticamente dal framework
  // tramite CtExportConfiguration
  //
  // Comportamento equivalente:
  // - Raccoglie automaticamente i filtri attivi dalla tabella
  // - Ignora la paginazione (includePagination = false)
  // - Chiama: this.modelService.export(config, body, { action: 'ExportExcelWorkOrderPayment' })
  // - Il framework gestisce tutto questo automaticamente in CtDatatableContainerComponent.onExport()
}
